import { INVENTORYANDSALES_URL } from "utils/constants";
import { ENDPOINTSINVENTORYANDSALES } from "utils/endpoints";
import { http } from "utils/http";

export const sendItemVariationLeaf = (async (data) => await http({
    baseURL:INVENTORYANDSALES_URL,
    url: ENDPOINTSINVENTORYANDSALES.Inventory.ItemApis.ItemTree.itemVariationLeaf,
    method: 'post',
    data:data
    
}).then((res) => {

    return res.data
}).catch((err) => {
 
    return Promise.reject( err);
})

)
export const putItemVariationLeaf = (async (data) => await http({
   baseURL:INVENTORYANDSALES_URL,
   url: ENDPOINTSINVENTORYANDSALES.Inventory.ItemApis.ItemTree.itemVariationLeaf,
   method: 'put',
   data:data
   
}).then((res) => {

   return res.data
}).catch((err) => {

   return Promise.reject( err);
})

)


export const getItemVariationLeaf = (id) => http({
    baseURL:INVENTORYANDSALES_URL,
   url: ENDPOINTSINVENTORYANDSALES.Inventory.ItemApis.ItemTree.itemVariationLeaf,
   method: "get",
   params:{
    Id:id
   }
}).then((res) => {
   return res.data
}).catch((err) => {
   return Promise.reject(err.response  );
});